<h1 mat-dialog-title class="d-flex align-items-center mb-0">
  <mat-icon class="mr-2">history</mat-icon>
  {{ 'inventory.popups.history.title' | translate }}
</h1>
<mat-card-subtitle>
  {{ 'inventory.popups.history.subtitle' | translate }}
</mat-card-subtitle>
<mat-divider></mat-divider>

<mat-dialog-content>
  <button
    style="visibility: hidden; position: absolute"
    cdkFocusInitial
  ></button>

  <mat-form-field class="filter-form-field">
    <span matPrefix>
      <mat-icon class="prefix-icon">filter_list</mat-icon>
    </span>
    <input
      #input
      matInput
      [placeholder]="'inventory.popups.history.filter' | translate"
      (input)="filterItems($any($event.target).value)"
      autocomplete="off"
      readonly
      (focus)="input.readOnly = false"
      (blur)="input.readOnly = true"
    />

    <button
      mat-button
      *ngIf="filterValue"
      matSuffix
      mat-icon-button
      aria-label="Clear"
      (click)="filterClear()"
    >
      <mat-icon>close</mat-icon>
    </button>
  </mat-form-field>

  <div *ngIf="historyData.length > 0; else noFilterItems">
    <div
      *ngFor="
        let history  of historyData
          | slice : pageIndex * pageSize : (pageIndex + 1) * pageSize
      "
    >
      <div [ngSwitch]="history.action">
        <div *ngSwitchCase="'Returned'">
          <p class="nameTag">{{ history.name }}</p>

          <p class="minfo-subtitle">
            <img [src]="history?.avatar" class="profile" alt="" />
            Lent Period
            <strong>{{ history.lend_on_date }}</strong> -
            <strong>{{ history.return_on_date }}</strong>
            <br />
          </p>
          <p class="remark">{{history.remarks}}</p>
        </div>
        <div *ngSwitchDefault></div>
      </div>
    </div>
  </div>
  <!--If there are no results-->
  <ng-template #noFilterItems>
    <app-no-results-found
      *ngIf="filteredItems.length === 0"
    ></app-no-results-found>
  </ng-template>
</mat-dialog-content>
<mat-paginator
  [length]="totalItems"
  [pageSize]="pageSize"
  [pageSizeOptions]="[5, 10, 25, 100]"
  (page)="onPageChange($event)"
  [pageIndex]="pageIndex"
  class="custom-paginator"
>
</mat-paginator>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>
    {{ 'workstations.popups.history.close' | translate }}
  </button>
</mat-dialog-actions>
